import {default as LeaderboardRepository} from "./LeaderboardRepository"
import {httpClient} from "Config";

export const leaderboardRepo = new LeaderboardRepository(httpClient)
